import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { TH, THContainer, THead } from '../../../styles/Table.styled';
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from 'array-move'
function TableHead(props) {
    const {
        setColumns,
        columns, 
        reverse, 
        setSortQuery, 
        setReverse, 
        getData, 
        selectedAllRows,
        setSelectedAllRows
    } = props;
    const { t } = useTranslation();
    const onSortEnd = (oldIndex, newIndex) => {
        setColumns((array) => arrayMoveImmutable(array, oldIndex, newIndex));

    };

    const columnClickHandler = (field) => {
        setSortQuery(field);
        let reverseValue= reverse[field] ? reverse[field] : false 
        let newReverse = { [field]: !reverseValue }
        setReverse(newReverse);
        getData(field,newReverse);
    }

    const selectAllRowsHandler = (e) => {
        //console.log(selectedAllRows)
        setSelectedAllRows(!selectedAllRows);
    }

    return (
        <>
            <THead>
                    <tr>
                        <TH key={"column123"} scope="col" width="50px" >
                            <THContainer style={{justifyContent: "center"}}>
                                <CheckIcon onClick={(e) => selectAllRowsHandler(e)} />
                            </THContainer>
                    </TH>

                    <SortableList style={{ display: "contents", justifyContent: 'flex-start' }}

                        draggedItemClassName='dragged'
                        lockAxis='x'
                        onSortEnd={onSortEnd}
                    >
                    {columns.filter(row => row.show == true).map(column => (
                        <SortableItem key={column.field}  >
                        <TH 
                                key={column.field} 
                                scope="col" 
                                id={column.field}
                                width={column.width} 
                                onClick={() => columnClickHandler(column.field)}
                            >
                                <THContainer style={{justifyContent: column?.alignSelf}}>
                                    <span>
                                        {t(`tableHead:${column.field}`, column.title)}
                                    </span>
                                    <ArrowUpwardIcon style={{fontSize: 20, display: reverse[column.field] === true ? 'block' : 'none'}} />
                                    <ArrowDownwardIcon style={{fontSize: 20, display: reverse[column.field] === false ? 'block' : 'none'}}/>
                                </THContainer>   
                            </TH>
                        </SortableItem>  
                            
                        ))}
                        <TH key={"column1453"} scope="col" width="100px" >
                            <THContainer style={{cursor: "default"}}>
                                    <span>{t('tableHead:actions', 'Actions')} </span>
                            </THContainer>
                        </TH>
                    </SortableList>
                    </tr>
            </THead>
        </>
    )
}

export default TableHead
